import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Components/Redux/store';
import { setAuth } from '../Components/Redux/authSlice';
import { Link } from 'react-router-dom';
import { FaMoneyBillWave, FaSearch, FaExclamationCircle, FaArrowRight } from 'react-icons/fa';
import './fees.css'; // Reusing fees css

const FeesPending: React.FC = () => {
    const [pendingFees, setPendingFees] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [monthFilter, setMonthFilter] = useState<string>('');

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);

    const getCookie = (name: string) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    };

    useEffect(() => {
        const fetchPendingFees = async () => {
            setLoading(true);
            try {
                const token = getCookie('token');
                if (!token) {
                    dispatch(setAuth(false));
                    return;
                }
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                let url = '/fees/fees-pending/';
                if (monthFilter) {
                    url += `?month=${monthFilter}`;
                }

                const response = await axios.get(url);
                setPendingFees(response.data);
                dispatch(setAuth(true));
            } catch (error) {
                console.error('Error fetching pending fees:', error);
                // setAuth(false) might handle redirects automatically if configured
            } finally {
                setLoading(false);
            }
        };

        fetchPendingFees();
    }, [monthFilter, dispatch]);

    const filteredData = pendingFees.filter(fee =>
        fee.student_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        fee.class_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="dashboard-content">
            {auth ? (
                <div className="fees-container">
                    {/* Header */}
                    <div className="fees-header">
                        <div className="header-content">
                            <div className="header-title">
                                <FaExclamationCircle className="header-icon text-warning" />
                                <div>
                                    <h2>Lacagaha Harsan (Qeyb La Bixiyay)</h2>
                                    <p className="header-subtitle">Ardayda leh haraaga lacag bixinta</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    <div className="filters-section">
                        <div className="filter-group">
                            <div className="search-wrapper">
                                <FaSearch className="search-icon" />
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="Raadi ardayga ama fasalka..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <select
                                className="month-filter"
                                value={monthFilter}
                                onChange={(e) => setMonthFilter(e.target.value)}
                            >
                                <option value="">Bishan</option>
                                {['January', 'February', 'March', 'April', 'May', 'June',
                                    'July', 'August', 'September', 'October', 'November', 'December']
                                    .map(month => (
                                        <option key={month} value={month}>{month}</option>
                                    ))}
                            </select>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-container">
                        {loading ? (
                            <div className="loading-state">
                                <div className="spinner"></div>
                                <p>Soo dejinaya lacagaha harsan...</p>
                            </div>
                        ) : (
                            <div className="table-wrapper">
                                <table className="modern-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Magaca Ardayga</th>
                                            <th>Fasalka</th>
                                            <th>Nooca Lacagta</th>
                                            <th>Bisha</th>
                                            <th>Wadarta Lacagta</th>
                                            <th>Inta La Bixiyay</th>
                                            <th>Haraaga</th>
                                            <th>Ficil</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan={9} className="empty-state">
                                                    <div className="text-center py-4">
                                                        <FaMoneyBillWave className="text-success fs-1 mb-2" />
                                                        <p>Lama helin lacag harsan oo qeyb la bixiyay!</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((fee, index) => (
                                                <tr key={fee.id} className="table-row">
                                                    <td>{index + 1}</td>
                                                    <td className="fw-bold">{fee.student_name}</td>
                                                    <td>{fee.class_name}</td>
                                                    <td>{fee.fee_structure_name}</td>
                                                    <td>{fee.month}</td>
                                                    <td>KSh {parseFloat(fee.total_amount || 0).toLocaleString()}</td>
                                                    <td className="text-success">KSh {parseFloat(fee.amount_paid_latest || 0).toLocaleString()}</td>
                                                    {/* Note: Backend returns amount_paid of Latest Transaction. 
                                We should display Total Paid So Far? 
                                Backend logic calculated balance correctly (Total - PaidSoFar).
                                So Balance Due IS correct.
                                'Paid So Far' = Total - Balance.
                             */}
                                                    <td className="text-danger fw-bold">KSh {parseFloat(fee.balance).toLocaleString()}</td>
                                                    <td>
                                                        <Link to="/add-fees" className="btn btn-sm btn-primary rounded-pill px-3">
                                                            Bixi Haraaga <FaArrowRight className="ms-1" />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                </div>
            ) : (
                <div className="auth-error">
                    <h4>Fadlan Soo Gal</h4>
                </div>
            )}
        </div>
    );
};

export default FeesPending;
